import type { CollaborationEligibility, Production, ProductionMember } from '@/api/studio-production'

export interface CollaborationGate {
  hasTeam: boolean
  hasCollab: boolean
  canAssignWork: boolean
  isOwner: boolean
  isDeptAdmin: boolean
  myDepartmentId: string | null
}

export function resolveCollaborationGate(
  production: Production | null,
  members: ProductionMember[],
  eligibility: CollaborationEligibility | null,
  userId?: number,
): CollaborationGate {
  const isOwner =
    production?.is_owner === true ||
    (production?.user_id != null && userId != null && production.user_id === userId)
  const me = userId != null ? members.find((m) => m.user_id === userId) : undefined
  const hasTeam = members.length > 1
  const hasCollab = eligibility?.has_studio_collaboration === true
  const isDeptAdmin = me?.is_department_admin === true
  const canAssignWork = hasCollab && hasTeam && (isOwner || isDeptAdmin)
  return {
    hasTeam,
    hasCollab,
    canAssignWork,
    isOwner,
    isDeptAdmin,
    myDepartmentId: me?.department_id ?? null,
  }
}
